import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '../material/RadioGroup';

class FormRadioGroup extends React.Component {

  static propTypes = {
    input: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  render() {
    const {children, input, ...restProps} = this.props;

    return (
      <RadioGroup {...restProps} {...input}>
        {children}
      </RadioGroup>
    );
  }

}

export default FormRadioGroup;



// WEBPACK FOOTER //
// ./src/components/common/material-form/RadioGroup.js